'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _documentUi = require('./document-ui');

var _documentUi2 = _interopRequireDefault(_documentUi);

var _colorPickerUi = require('./color-picker-ui');

var _colorPickerUi2 = _interopRequireDefault(_colorPickerUi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WhiteLabelingApp = function (_React$Component) {
    _inherits(WhiteLabelingApp, _React$Component);

    function WhiteLabelingApp(props) {
        _classCallCheck(this, WhiteLabelingApp);

        var _this = _possibleConstructorReturn(this, (WhiteLabelingApp.__proto__ || Object.getPrototypeOf(WhiteLabelingApp)).call(this, props));

        _this.state = {
            selectedColor: '#000000',
            blinkingComponent: 'DocumentHeader'
        };
        return _this;
    }

    _createClass(WhiteLabelingApp, [{
        key: 'handleChange',
        value: function handleChange(color) {
            this.setColor('' + color.hex);
        }
    }, {
        key: 'setColor',
        value: function setColor(color) {
            this.setState({ selectedColor: color });
        }
    }, {
        key: 'changeBlinkingComponent',
        value: function changeBlinkingComponent(component) {
            if (component === 'DocumentHeader') {
                this.setState({ blinkingComponent: 'ColorPickerUI' });
            } else {
                this.setState({ blinkingComponent: null });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var props = _extends({
                handleChange: this.handleChange.bind(this),
                setColor: this.setColor.bind(this),
                changeBlinkingComponent: this.changeBlinkingComponent.bind(this)
            }, this.state);
            return _react2['default'].createElement(
                'div',
                { className: 'm-white-labeling-app' },
                _react2['default'].createElement('img', {
                    src: require('./assets/white_labeling_social_media.gif'),
                    'aria-hidden': true,
                    className: 'white-labeling-gif'
                }),
                _react2['default'].createElement(_documentUi2['default'], props),
                _react2['default'].createElement(_colorPickerUi2['default'], props)
            );
        }
    }]);

    return WhiteLabelingApp;
}(_react2['default'].Component);

module.exports = WhiteLabelingApp;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api/white-labeling/index.jsx
 ** module id = 1274
 ** module chunks = 0
 **/